import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const legaleasePreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#f0f7fc',
            100: '#dcedf8',
            200: '#bfddf2',
            300: '#92c7e9',
            400: '#5eaade',
            500: '#1a87d0',  // Brand blue
            600: '#1270b3',
            700: '#105a91',
            800: '#124b77',
            900: '#144064',
        },
        success: {
            50: '#f3fef4',
            100: '#e5fde7',
            200: '#c9fad0',
            300: '#9af5a5',
            400: '#6cf372',  // Brand green
            500: '#39dc42',
            600: '#25b92d',
            700: '#1f9126',
            800: '#1e7324',
            900: '#195f21',
        },
        warning: {
            50: '#fffbeb',
            100: '#fef3c7',
            200: '#fde68a',
            300: '#fcd34d',
            400: '#fbbf24',
            500: '#f59e0b',
            600: '#d97706',
            700: '#b45309',
            800: '#92400e',
            900: '#78350f',
        }
    },
    colors: {
        // Custom surface colors to match our glassmorphic UI
        'surface-ground': 'rgb(248 250 252)',  // bg-slate-50
        'surface-card': 'rgba(255, 255, 255, 0.3)',  // bg-white/30
        'surface-overlay': 'rgba(255, 255, 255, 0.3)',
        'surface-border': 'rgba(255, 255, 255, 0.5)',  // border-white/50
        
        // Shadow colors for our consistent design
        'shadow-1': '0 1px 2px 0 rgb(0 0 0 / 0.05)',
        'shadow-2': '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    }
});